type Props = {
	size?: number
	color?: string
	strokeWidth?: number
}

export const PlusIcon = ({ size = 24, color = "#0047FF", strokeWidth = 2 }: Props) => {
	return (
		<svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M4.91797 11.9883H19.0497"
				stroke={color}
				strokeWidth={strokeWidth}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M11.9844 19.0536V4.92188"
				stroke={color}
				strokeWidth={strokeWidth}
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	)
}
